export default __webpack_public_path__ + "ed43f47.mp3";